import { Grid } from "@genie-ui/react";
import "./app.scss";

const FooterTop = ({ footerTopData }) => {
    return (
        <div>
            {footerTopData.length > 0 &&
                <div className="genie-footer-top">
                    <Grid container className="genie-footer-top-links__container">
                        {footerTopData?.map((link) => (
                            <Grid item key={link?.label} >
                                <a href={link?.url} className="genie-footer-top-links" rel="noreferer noopener" target="_blank">
                                    {link?.label || ''}
                                </a>
                            </Grid>
                        ))}
                        <hr className="genie-footer-top__divider" />
                    </Grid>
                </div>
            }
        </div>
    );
};

export default FooterTop;

